import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from '../base/Icon';
import type { BaseIconProps } from '../types';
const Opera: React.FC<BaseIconProps> = t0 => {
  const $ = _c(5);
  const {
    size: t1,
    width,
    height
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Path d="M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Zm0,35c-5.26,0-10-6.9-10-15S14.74,5,20,5s10,6.9,10,15S25.26,35,20,35Z" fill="#ff1744" />;
    t3 = <Path d="M32.56,4.44A13.06,13.06,0,0,0,25.26,2,13.45,13.45,0,0,0,15.1,7.08,7.42,7.42,0,0,1,20,5c5.26,0,10,6.9,10,15S25.26,35,20,35a7.42,7.42,0,0,1-4.9-2.08A13.45,13.45,0,0,0,25.26,38a13.06,13.06,0,0,0,7.3-2.44,20,20,0,0,0,0-31.12Z" fill="#d50000" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== iconHeight || $[3] !== iconWidth) {
    t4 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 40 40" fill="none">{t2}{t3}</Icon>;
    $[2] = iconHeight;
    $[3] = iconWidth;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Opera;